const laboratoriesActionTypes = {
  FETCH_ALL_LABS_WITH_FILTERS: 'FETCH_ALL_LABS_WITH_FILTERS',
  FETCH_ALL_LABS_WITH_FILTERS_SUCCESS: 'FETCH_ALL_LABS_WITH_FILTERS_SUCCESS',
  FETCH_ALL_LABS_WITH_FILTERS_FAIL: 'FETCH_ALL_LABS_WITH_FILTERS_FAIL',
  FETCH_ADD_LAB_SUBMISSION: 'FETCH_ADD_LAB_SUBMISSION',
  FETCH_ADD_LAB_SUBMISSION_SUCCESS: 'FETCH_ADD_LAB_SUBMISSION_SUCCESS',
  FETCH_ADD_LAB_SUBMISSION_FAIL: 'FETCH_ADD_LAB_SUBMISSION_FAIL',
};

export default laboratoriesActionTypes;
